<script>
  import { mapState } from 'vuex';
  import Chunk from 'lodash/chunk';
  import DonutWallet from '@/components/Wallet/Donut';
  import CryptoDashboard from '@/components/Dashboard/Crypto';

  export default {
    components: {
      DonutWallet,
      CryptoDashboard,
    },

    computed: {
      ...mapState('coins', [
        'coins',
      ]),

      chunks () {
        return Chunk(this.coins, 3);
      },
    },

    methods: {
      redirect (initial, path) {
        this.$store.commit('coins/SET_ACTIVE', initial);

        this.$router.push(path);
      },
    },
  };
</script>

<template>
  <main class="dash container container--padding">
    <article class="dash__charts">
      <div
        class="row"
        :key="i" v-for="(row, i) in chunks"
        >
        <CryptoDashboard
          :key="j"
          :coin="coin"
          class="col--4"
          v-for="(coin, j) in row"
          @click.prevent="redirect(coin.initial, '/negociar')"
          />
      </div>
    </article>

    <div class="row">
      <article class="col--8 card dash-wallet">
        <header class="card__header">
          <h1 class="card__title">Carteira</h1>
        </header>

        <div class="dash-wallet__body">
          <DonutWallet class="dash-wallet__donut" />

          <div class="dash-wallet__content">
            <div
              :key="initial"
              class="dash-wallet__crypto"
              :style="{ borderColor: color }"
              @click.prevent="redirect(initial, '/carteira')"
              v-for="({ initial, formated, color }) in coins"
              >
              <span
                v-text="initial"
                :style="{ color }"
                class="dash-wallet__initial"
                >
              </span>
              {{ formated }}
            </div>
          </div>
        </div>
      </article>

      <section class="col--4 dash-posts">
        <article class="dash-posts__post card dash-posts__post--blue">
          <img
            class="dash-posts__background"
            src="/image/bitcoin-thumb.jpg"
            >
          <a href="https://google.com.br" target="_blank" class="dash-posts__content">
            <h1 class="dash-posts__title">
              Segurança é prioridade no Coinbrax
            </h1>

            <p class="dash-posts__description">Lorem ipsum dolor sit amet, consectetur adipiscing elit</p>
          </a>
        </article>

        <article class="dash-posts__post card dash-posts__post--purple">
          <img
            class="dash-posts__background"
            src="/image/bitcoin-thumb.jpg"
            >

          <a href="https://google.com.br" target="_blank" class="dash-posts__content">
            <h1 class="dash-posts__title">
              Segurança é prioridade no Coinbrax
            </h1>

            <p class="dash-posts__description">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
          </a>
        </article>
      </section>
    </div>
  </main>
</template>

<style lang="scss">
  .dash {
    &__charts {
      margin-bottom: 45px;
    }

    &-label {
      border: 0;
      color: #FFF;
      padding: 4px 8px;
      font-weight: 300;
      font-family: Rubik;
      letter-spacing: .3px;
      background-color: #14162f;

      &__initial {
        margin-right: 8px;
      }
    }

    &-wallet {
      display: flex;
      flex-direction: column;

      $margin_bottom: 48;

      &__body {
        flex: 1;
        display: flex;
      }

      &__content {
        flex: 1;
        display: flex;
        flex-wrap: wrap;
        padding-left: 0;
        align-items: center;
        margin-bottom: -#{$margin_bottom}px;
        align-content: center;
        padding: 48px 0 48px 39px;
      }

      &__crypto {
        width: 187px;
        color: #FFF;
        display: flex;
        cursor: pointer;
        padding-left: 8px;
        border-left: 2px solid;
        flex-direction: column;
        margin-bottom: #{$margin_bottom}px;
      }

      &__initial {
        font-size: 14px;
        letter-spacing: 0;
        line-height: 14px;
        margin-bottom: 1px;
      }

      &__donut {
        margin-left: 5px;
      }
    }

    &-posts {

      &__post {
        height: 173px;
        position: relative;

        &--blue {
          margin-bottom: 16px;
          background-color: #0081e3;
        }

        &--purple {
          background-color: #6e67cb;
        }
      }

      &__content {
        z-index: 2;
        height: 100%;
        color: #FFF;
        padding: 24px;
        display: flex;
        position: relative;
        flex-direction: column;
        justify-content: space-between;
      }

      &__title {
        font-size: 20px;
        max-width: 123px;
        }

      &__description {
        opacity: 0.8;
        font-size: 13px;
        max-width: 208px;
        line-height: 1.46;
      }

      &__background {
        top: 0;
        left: 0;
        z-index: 1;
        opacity: .15;
        width: 100%;
        height: 100%;
        position: absolute;
      }
    }
  }
</style>
